export default __webpack_public_path__ + "static/media/ic_trash_r.91ff2992.svg";